import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import SelectParameterForm from "./components/SelectParameterForm";
import ParameterCard from "./components/ParameterCard";
import { FormFields as OptimizationFormFields } from "../../../../index";
import HiddenInput from "rs-components/Input/components/HiddenInput";
import Input from "rs-components/Input";
import { ParameterFormFields } from "../../index";
import { OptimizationParameterParameterType, } from "store/rs-workspace/rs-workspace.types";
import { getFieldRestrictions, getRequestName } from "store/knowledge-base-item/knowledge-base-item.utils";
import { getOptimizationParameterSectionTarget, getSelectedParameterToOptimize, } from "store/rs-workspace/utils/common.utils";
import { isNotEmpty } from "utils/validate";
import * as styles from "./styles.module.scss";
import { workspaceCellModelsSelector, workspaceRecipesSelector, } from "store/rs-workspace/selectors/rs-workspace.selectors";
const Parameter = ({ name, renderProps, index, targetSource, targetType, restrictions }) => {
    const { fields } = renderProps;
    const parameter = fields.value?.[index];
    const cellModels = useSelector(workspaceCellModelsSelector);
    const recipes = useSelector(workspaceRecipesSelector);
    const target = useMemo(() => getOptimizationParameterSectionTarget(recipes, cellModels, targetSource, targetType), [cellModels, recipes, targetSource, targetType]);
    const usedVariantStepFlows = useMemo(() => targetSource?.adjustmentId !== 0
        ? (targetSource?.source.state.adjustments?.find(({ id }) => id === targetSource.adjustmentId)
            ?.flowConfig?.stepsConfig ?? undefined)
        : undefined, [targetSource?.adjustmentId, targetSource?.source.state.adjustments]);
    const parameterOverrides = useMemo(() => targetSource?.adjustmentId !== 0
        ? targetSource?.source.parametersForVariants?.[targetSource.adjustmentId]
        : undefined, [targetSource?.adjustmentId, targetSource?.source.parametersForVariants]);
    const selectedParameter = useMemo(() => target &&
        targetType &&
        getSelectedParameterToOptimize(parameter, target, targetType, parameterOverrides), [parameter, parameterOverrides, target, targetType]);
    const parameterRestrictions = useMemo(() => getFieldRestrictions(restrictions, [
        getRequestName(OptimizationFormFields.state_parameters),
        "OptimizationParametersSet",
        "Parameters",
    ]), [restrictions]);
    const parameterIdRestrictions = useMemo(() => getFieldRestrictions(parameterRestrictions, parameter?.type === OptimizationParameterParameterType.ALTERNATIVE_FLOW
        ? ["AlternativeFlow", ParameterFormFields.stepId]
        : ["CellModelOrRecipe", ParameterFormFields.parameterId]), [parameter?.type, parameterRestrictions]);
    const shouldRemoveWithConfirmation = useMemo(() => {
        switch (parameter?.type) {
            case OptimizationParameterParameterType.CELL_MODEL_OR_RECIPE:
                return isNotEmpty(parameter?.min) || isNotEmpty(parameter?.max);
            case OptimizationParameterParameterType.ALTERNATIVE_FLOW:
                return (parameter?.flowIds?.length ?? 0) > 1;
            default:
                return false;
        }
    }, [parameter]);
    const removeAction = useCallback((isConfirmed) => isConfirmed && fields.remove(index), [fields, index]);
    return (React.createElement("div", { key: `${name}-${index}-${fields.length}`, className: styles.parameter },
        React.createElement(Input, { component: HiddenInput, name: `${name}.${parameter?.type === OptimizationParameterParameterType.ALTERNATIVE_FLOW
                ? ParameterFormFields.stepId
                : ParameterFormFields.parameterId}`, restrictions: parameterIdRestrictions }),
        parameter?.notSaved || selectedParameter === undefined ? (target &&
            targetType && (React.createElement(SelectParameterForm, { renderProps: renderProps, index: index, target: target, targetType: targetType, parameterOverrides: parameterOverrides, usedVariantStepFlows: usedVariantStepFlows, restrictions: parameterIdRestrictions }))) : (React.createElement(ParameterCard, { index: index, name: name, parameter: selectedParameter, restrictions: parameterRestrictions, removeAction: removeAction, removeWithConfirmation: shouldRemoveWithConfirmation }))));
};
export default Parameter;
